module.exports = __webpack_public_path__ + "static/media/SARS-GSE56192.66651b38.csv";